export enum TipoPedido {
  RENOVACAO_REGISTRO_VEICULO =  "Renovação do Registro de Veículo",
  CADASTRO_EMPRESA = 'CADASTRO_EMPRESA'
}
